<template>
  <div class="news">
    <div class="newsHTML">
      <div class="img-box">
        <div class="big-title">
          <h2>{{ newss.news_TITLE }}</h2>
        </div>
        <div class="tine-box">
          <p>
            <time :datetime="newss.new_CREATE_DATE">{{ newss.new_CREATE_DATE | formatTimer }}</time>
          </p>
        </div>
        <img :src="$imagepath + newss.news_FILE_PATH">
      </div>
      <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }"><span class="breadcrumbs_list">首页</span></el-breadcrumb-item>
          <el-breadcrumb-item><span class="breadcrumbs_list">新闻</span></el-breadcrumb-item>
          <el-breadcrumb-item><span class="breadcrumbs_list">{{ newss.news_TITLE }}</span></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="news-contain">

        <iframe :src="$imagepath + newss.newsFilePath" frameborder="0" scrolling="no"></iframe>

      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  created() {
    // this.showNews()  
  },
  props: ['newss', 'userType'],
  filters: {
    formatTimer: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      // return y + "-" + MM + "-" + d + " " + h + ":" + m;
      return y + "年" + MM + "月" + d;
    }
  },
  data() {
    return {
      new: {},
      htmlURLs: '',
      imagepath: '',
      //  src:"http://192.168.31.129/group1/M00/00/00/wKgfgWLIW3GAYLJuAABGQ9prv7w25.html"
    }
  }, mounted() {


  },
  methods: {
    showNews() {
      //  this.htmlURLs=this.$route.query.newsHtmlURL
      this.axios.post("/news/getNewsById", "NEWSID=" + this.NEWSID)
        .then(resp => {
          if (resp.data.status == 1) {
            this.news = resp.data.result
            console.log(resp.data.result)
          } else {
            this.$message.error("获取数据失败")
          }
        })
        .catch((err) => {
          alert("出错")
          console.log(err)
        })

      this.imagepath = this.$imagepath
    },
  }
}
</script>
  
<style scoped>
.newsHTML {
  width: 1085.78px;
  height: 100%;
  margin: auto;

  padding-top: 0;

}

iframe {
  width: 100%;
  height: 5000px;

}

.img-box {
  height: 100%;
  width: 1085.78px;

}

img {
  width: 100%;
  height: 100%;
  overflow: hidden;

}

.big-title {
  width: 1085.78px;
  position: absolute;
  margin-top: 120px;
  padding-left: 25px;
}

.tine-box {
  position: absolute;
  margin-top: 300px;

}

h2 {
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 45px;
  line-height: 1.4;
  text-transform: uppercase;
  color: #fff;
  padding: 12px;
  font-weight: 15px;
}

p {
  color: #fff;
  padding-left: 49.35px;
}

.breadcrumbs_list {
  margin: 0;
  padding: 0;
  border: none;
  font-size: 14px;
  vertical-align: baseline;
  color: #333;
  line-height: 28px;
  font-weight: 600;
}

.news-contain {
  background-color: #fff;
  width: 100%;
  height: 100%;
  margin-top: 20px;
}

.news {

  background: #F4F4F4;
  overflow-y: hidden
}

.el-main {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/work/leader/ShowNews.vue